export const aggregates = {
  stateCounts: {
    key: "StateCounts"
  },
  districtCounts: {
    key: "CountsByDistrictId",
    groupedByKey: {
      districtId: "DistrictId"
    }
  },
  entityCounts: {
    key: "CountsByEntityId",
    groupedByKey: {
      entityId: "EntityId"
    }
  }
};

export const alphaLabels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const reportTypes = {
  individual: {
    icon: "sliders-h",
    label: "Individual Item Analysis",
    name: "item-analysis",
    settings: {
      useAgg(agg) {
        return nSizeCheck(newTeacherKeys, 5, agg);
      }
    }
  },
  agree: {
    icon: "table",
    label: "Agree Analysis",
    name: "agree-analysis",
    settings: {
      useAgg(agg) {
        return nSizeCheck(newTeacherKeys, 5, agg);
      }
    }
  },
  agreeHistory: {
    icon: "history",
    label: "Historical Analysis",
    name: "agree-analysis-historical",
    settings: {
      useAgg(agg) {
        return nSizeCheck(newTeacherKeys, 5, agg);
      }
    }
  },
  principal_individual: {
    icon: "sliders-h",
    label: "Item Analysis",
    name: "item-analysis"
  },
  principal_agree: {
    icon: "table",
    label: "Agree Analysis",
    name: "agree-analysis"
  }
};

const principalKeys = [
  "tbl_2",
  "V51",
  "tbl_3",
  "tbl_5",
  "tbl_7",
  "tbl_9",
  "tbl_12",
  "tbl_13",
  "tbl_15",
  "tbl_16",
  "tbl_20",
  "tbl_21",
  "V225",
  "V226",
  "tbl_23",
  "V250",
  "V252",
  "V340",
  "tbl_35",
  "tbl_36",
  "tbl_37",
  "V358",
  "V359",
  "tbl_25",
  "tbl_29",
  "V290",
  "V291",
  "tbl_30",
  "V296",
  "V297",
  "V298",
  "V299",
  "V300"
];
const teacherKeys = [
  "tmlgrid",
  "tmtreal",
  "tmt046outside",
  "frlgrid",
  "frl105hunger",
  "cslgrid",
  "sclgrid",
  "emlgrid",
  "emlreal",
  "eml021schinflu",
  "exl012sipelected",
  "ldlgrid",
  "pdlgrid",
  "pdtneed",
  "pdthad",
  "iplgrid",
  "ovt060intentimm",
  "ovt078willing",
  "ovl078promote",
  "ovl021overall",
  "ovl021usetwcdata",
  "mntsupt",
  "mntact",
  "mntinflu",
  "mnttrue",
  "mnt021impinst",
  "mnt021impactsl",
  "mnt021decide",
  "tbl_24",
  "tbl_26",
  "V272",
  "V273",
  "tbl_27",
  "tbl_28",
  "V282",
  "V283",
  "V284",
  "V285",
  "V286"
];

const newTeacherKeys = [
  "V301",
  "mnt010supmentor",
  "mnt010supsemin",
  "mnt010supredwk",
  "mnt010supcompln",
  "mnt010suprlstm",
  "mnt010supfmltm",
  "mnt010suporient",
  "mnt010supplc",
  "mnt010supadmin",
  "mnt010supother",
  "mnt010supnone",
  "mnt032devplns",
  "mnt032observed",
  "mnt032observing",
  "mnt032azstuwk",
  "mnt032asmts",
  "mnt032behavior",
  "mnt032reflectoge",
  "mnt032align",
  "mnt032other",
  "mnt035inststrat",
  "mnt035content",
  "mnt035clsmgmt",
  "mnt035dataid",
  "mnt035diffneed",
  "mnt035equity",
  "mnt035enlistfam",
  "mnt035collab",
  "mnt035resoprof",
  "mnt035comply",
  "mnt035pprwk",
  "mnt035emosupt",
  "mnt035other",
  "mnt010build",
  "mnt010content",
  "mnt010grade",
  "mnt021impinst",
  "mnt021impactsl",
  "mnt021decide"
];

export const reportSelectOptions = [
  {
    text: "2024",
    value: "2024_NCTWCS",
    disabled: false,
    reports: {
      individual: {
        ...reportTypes.individual,
        settings: {
          hide: principalKeys,
          useAgg(agg) {
            return nSizeCheck(newTeacherKeys, 5, agg);
          }
        }
      },
      agree: {
        ...reportTypes.agree,
        settings: {
          hide: principalKeys,
          useAgg(agg) {
            return nSizeCheck(newTeacherKeys, 5, agg);
          }
        }
      },
      agreeHistory: {
        ...reportTypes.agreeHistory,
        settings: {
          columnLabel: "2024",
          compareTo: [
            {
              id: "2022_NCTWCS",
              label: "2022"
            },
            {
              id: "2020_NCTWCS",
              label: "2020"
            }
          ],
          hide: principalKeys.concat([
            "ldpgrid",
            "ldleffort",
            "mnt021impinst",
            "mnt021impactsl",
            "mnt021decide"
          ]),
          useAgg(agg) {
            return nSizeCheck(newTeacherKeys, 5, agg);
          }
        }
      }
    },
    principalReports: {
      individual: {
        ...reportTypes.principal_individual,
        settings: {
          hide: teacherKeys
        }
      },
      agree: {
        ...reportTypes.principal_agree,
        settings: {
          hide: teacherKeys
        }
      }
    }
  },
  {
    text: "2022",
    value: "2022_NCTWCS",
    disabled: false,
    reports: {
      individual: {
        ...reportTypes.individual,
        settings: {
          hide: principalKeys,
          useAgg(agg) {
            return nSizeCheck(newTeacherKeys, 5, agg);
          }
        }
      },
      agree: {
        ...reportTypes.agree,
        settings: {
          hide: principalKeys,
          useAgg(agg) {
            return nSizeCheck(newTeacherKeys, 5, agg);
          }
        }
      },
      agreeHistory: {
        ...reportTypes.agreeHistory,
        settings: {
          columnLabel: "2022",
          compareTo: [
            {
              id: "2020_NCTWCS",
              label: "2020"
            },
            {
              id: "2018_NCTWCS",
              label: "2018",
            }
          ],
          hide: principalKeys.concat([
            "ldpgrid",
            "ldleffort",
            "mnt021impinst",
            "mnt021impactsl",
            "mnt021decide"
          ]),
          useAgg(agg) {
            return nSizeCheck(newTeacherKeys, 5, agg);
          }
        }
      }
    },
    principalReports: {
      individual: {
        ...reportTypes.principal_individual,
        settings: {
          hide: teacherKeys
        }
      },
      agree: {
        ...reportTypes.principal_agree,
        settings: {
          hide: teacherKeys
        }
      }
    }
  },
  {
    text: "2020",
    value: "2020_NCTWCS",
    disabled: false,
    reports: {
      individual: {
        ...reportTypes.individual,
        settings: {
          hide: principalKeys,
          useAgg(agg) {
            return nSizeCheck(newTeacherKeys, 5, agg);
          }
        }
      },
      agree: {
        ...reportTypes.agree,
        settings: {
          hide: principalKeys,
          useAgg(agg) {
            return nSizeCheck(newTeacherKeys, 5, agg);
          }
        }
      },
      agreeHistory: {
        ...reportTypes.agreeHistory,
        settings: {
          columnLabel: "2020",
          compareTo: [
            {
              id: "2018_NCTWCS",
              label: "2018"
            },
            {
              id: "2016_NCTWCS",
              label: "2016",
              hide: ["ipl021gauge", "ipl021statedata"]
            }
          ],
          hide: principalKeys.concat([
            "ldpgrid",
            "ldleffort",
            "mnt021impinst",
            "mnt021impactsl",
            "mnt021decide"
          ]),
          useAgg(agg) {
            return nSizeCheck(newTeacherKeys, 5, agg);
          }
        }
      }
    },
    principalReports: {
      individual: {
        ...reportTypes.principal_individual,
        settings: {
          hide: teacherKeys
        }
      },
      agree: {
        ...reportTypes.principal_agree,
        settings: {
          hide: teacherKeys
        }
      }
    }
  },
  // {
  //   text: "2018",
  //   value: "2018_NCTWCS",
  //   disabled: false,
  //   reports: {
  //     individual: reportTypes.individual,
  //     agree: reportTypes.agree,
  //     agreeHistory: {
  //       ...reportTypes.agreeHistory,
  //       settings: {
  //         columnLabel: "2018",
  //         compareTo: [
  //           {
  //             id: "2016_NCTWCS",
  //             label: "2016"
  //           }
  //         ],
  //         useAgg(agg) {
  //           return nSizeCheck(newTeacherKeys, 5, agg);
  //         }
  //       }
  //     }
  //   }
  // },
  // {
  //   text: "2016",
  //   value: "2016_NCTWCS",
  //   disabled: false,
  //   reports: {
  //     individual: reportTypes.individual,
  //     agree: reportTypes.agree
  //   },
  //   hide: ["NC16ipl021statedata", "NC16ipl021gauge"]
  // }
];

// TO DO: Move this detail to db survey.question options!
export const agreeOptionGroups = [
  [
    { text: "Strongly disagree", value: "1", isAgree: false },
    { text: "Disagree", value: "2", isAgree: false },
    { text: "Agree", value: "3", isAgree: true },
    { text: "Strongly agree", value: "4", isAgree: true },
    {
      text: "Don't know",
      value: "5",
      isAgree: false,
      isDontKnow: true,
      optional: true,
    },
  ],[
    { text: "Strongly disagree", value: "1", isAgree: false },
    { text: "Disagree", value: "2", isAgree: false },
    { text: "Agree", value: "3", isAgree: true },
    { text: "Strongly agree", value: "4", isAgree: true },
  ],
  [
    { text: "Strongly disagree", value: "A1", isAgree: false },
    { text: "Disagree", value: "A2", isAgree: false },
    { text: "Agree", value: "A3", isAgree: true },
    { text: "Strongly agree", value: "A4", isAgree: true },
    {
      text: "Don't know",
      value: "A5",
      isAgree: false,
      isDontKnow: true,
      optional: true,
    },
  ],
  [
    { text: "Strongly disagree", value: "A1", isAgree: false },
    { text: "Disagree", value: "A2", isAgree: false },
    { text: "Agree", value: "A3", isAgree: true },
    { text: "Strongly agree", value: "A4", isAgree: true },
  ],
  [
    { text: "Strongly disagree", value: "A1", isAgree: false },
    { text: "Disagree", value: "A2", isAgree: false },
    { text: "Agree", value: "A3", isAgree: true },
    { text: "Strongly agree", value: "A4", isAgree: true },
    {
      text: "Don't know",
      value: "A05",
      isAgree: false,
      isDontKnow: true,
      optional: true,
    },
  ],
  [
    { text: "Strongly disagree", value: "SQ001", isAgree: false },
    { text: "Disagree", value: "SQ002", isAgree: false },
    { text: "Agree", value: "SQ003", isAgree: true },
    { text: "Strongly agree", value: "SQ004", isAgree: true },
    {
      text: "Don't know",
      value: "A1",
      isAgree: false,
      isDontKnow: true,
      optional: true,
    },
  ],
  [
    { text: "Strongly disagree", value: "SQ001", isAgree: false },
    { text: "Disagree", value: "SQ002", isAgree: false },
    { text: "Agree", value: "SQ003", isAgree: true },
    { text: "Strongly agree", value: "SQ004", isAgree: true },
    {
      text: "Don't know",
      value: "SQ005",
      isAgree: false,
      isDontKnow: true,
      optional: true,
    },
  ],
  [
    { text: "Strongly disagree", value: "SQ001", isAgree: false },
    { text: "Disagree", value: "SQ002", isAgree: false },
    { text: "Agree", value: "SQ003", isAgree: true },
    { text: "Strongly agree", value: "SQ004", isAgree: true }
  ], 
  [
    { text: "Strongly disagree", value: "SQ001", isAgree: false },
    { text: "Disagree", value: "SQ002", isAgree: false },
    { text: "Agree", value: "SQ003", isAgree: true },
    { text: "Strongly agree", value: "SQ004", isAgree: true },
    {
      text: "Don't know",
      value: "A1",
      isAgree: false,
      isDontKnow: true,
      optional: true,
    },
  ],
  [
    { text: "Strongly disagree", value: "AO01", isAgree: false },
    { text: "Disagree", value: "AO02", isAgree: false },
    { text: "Agree", value: "AO03", isAgree: true },
    { text: "Strongly agree", value: "AO04", isAgree: true },
    {
      text: "Don't know",
      value: "AO05",
      isAgree: false,
      isDontKnow: true,
      optional: true,
    },
  ],
  [
    { text: "Strongly disagree", value: "A1", isAgree: false },
    { text: "Disagree", value: "A2", isAgree: false },
    { text: "Agree", value: "A3", isAgree: true },
    { text: "Strongly agree", value: "A04", isAgree: true },
    {
      text: "Don't know",
      value: "A05",
      isAgree: false,
      isDontKnow: true,
      optional: true,
    },
  ],
  [
    { text: "Strongly disagree", value: "A1", isAgree: false },
    { text: "Disagree", value: "A02", isAgree: false },
    { text: "Agree", value: "A03", isAgree: true },
    { text: "Strongly agree", value: "A04", isAgree: true },
    {
      text: "Don't know",
      value: "A05",
      isAgree: false,
      isDontKnow: true,
      optional: true,
    },
  ],
];

// export const agreeOptionGroups = [
//   [
//     { text: "Strongly disagree", value: "1", isAgree: false },
//     { text: "Disagree", value: "2", isAgree: false },
//     { text: "Agree", value: "3", isAgree: true },
//     { text: "Strongly agree", value: "4", isAgree: true },
//     {
//       text: "Don't know",
//       value: "5",
//       isAgree: false,
//       isDontKnow: true,
//       optional: true
//     }
//   ],
//   [
//     { text: "Strongly disagree", value: "A1", isAgree: false },
//     { text: "Disagree", value: "A2", isAgree: false },
//     { text: "Agree", value: "A3", isAgree: true },
//     { text: "Strongly agree", value: "A4", isAgree: true },
//     {
//       text: "Don't know",
//       value: "A5",
//       isAgree: false,
//       isDontKnow: true,
//       optional: true
//     }
//   ],
//   [
//     { text: "Strongly disagree", value: "A1", isAgree: false },
//     { text: "Disagree", value: "A2", isAgree: false },
//     { text: "Agree", value: "A3", isAgree: true },
//     { text: "Strongly agree", value: "A4", isAgree: true },
//     {
//       text: "Don't know",
//       value: "A05",
//       isAgree: false,
//       isDontKnow: true,
//       optional: true
//     }
//   ],
//   [
//     { text: "Strongly disagree", value: "SQ001", isAgree: false },
//     { text: "Disagree", value: "SQ002", isAgree: false },
//     { text: "Agree", value: "SQ003", isAgree: true },
//     { text: "Strongly agree", value: "SQ004", isAgree: true },
//     {
//       text: "Don't know",
//       value: "A1",
//       isAgree: false,
//       isDontKnow: true,
//       optional: true
//     }
//   ],
//   [
//     { text: "Strongly disagree", value: "SQ001", isAgree: false },
//     { text: "Disagree", value: "SQ002", isAgree: false },
//     { text: "Agree", value: "SQ003", isAgree: true },
//     { text: "Strongly agree", value: "SQ004", isAgree: true },
//     {
//       text: "Don't know",
//       value: "SQ005",
//       isAgree: false,
//       isDontKnow: true,
//       optional: true
//     }
//   ],
//   [
//     { text: "Strongly disagree", value: "AO01", isAgree: false },
//     { text: "Disagree", value: "AO02", isAgree: false },
//     { text: "Agree", value: "AO03", isAgree: true },
//     { text: "Strongly agree", value: "AO04", isAgree: true },
//     {
//       text: "Don't know",
//       value: "AO05",
//       isAgree: false,
//       isDontKnow: true,
//       optional: true
//     }
//   ],
//   [
//     { text: "Strongly disagree", value: "A1", isAgree: false },
//     { text: "Disagree", value: "A2", isAgree: false },
//     { text: "Agree", value: "A3", isAgree: true },
//     { text: "Strongly agree", value: "A04", isAgree: true },
//     {
//       text: "Don't know",
//       value: "A05",
//       isAgree: false,
//       isDontKnow: true,
//       optional: true
//     }
//   ],
//   [
//     { text: "Strongly disagree", value: "A1", isAgree: false },
//     { text: "Disagree", value: "A02", isAgree: false },
//     { text: "Agree", value: "A03", isAgree: true },
//     { text: "Strongly agree", value: "A04", isAgree: true },
//     {
//       text: "Don't know",
//       value: "A05",
//       isAgree: false,
//       isDontKnow: true,
//       optional: true
//     }
//   ]
// ];

export const agreeColors = [
  {
    label: "Greater than or equal to 70%",
    floor: 0.7,
    classes: "threshold-colors-1 elevation-2"
  },
  {
    label: "Greater than or equal to 50%",
    floor: 0.5,
    classes: "threshold-colors-3 white--text elevation-2"
  },
  {
    label: "Greater than or equal to 30%",
    floor: 0.3,
    classes: "threshold-colors-4 elevation-2"
  },
  {
    label: "Below 30%",
    floor: 0,
    classes: "threshold-colors-5 white--text elevation-2"
  }
];

function nSizeCheck(qualifyingKeys, nSize, { key, counts }) {
  let qualifies = qualifyingKeys.some(x => x === key);
  if (qualifies) {
    let filtered = counts.filter(
      x => ![undefined, null, ""].some(y => y === x.key)
    );

    let sum = filtered.reduce((count, item) => {
      return count + item.value;
    }, 0);

    if (sum < nSize) return false;
  }

  return true;
}
